(function() {
    'use strict';

    angular
        .module('telestatApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('phone-call-result-group', {
            /*
            parent: 'entity',
            */
            parent: 'dictionary',
            url: '/phone-call-result-group?page&sort&search',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'telestatApp.phoneCallResultGroup.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/phone-call-result-group/phone-call-result-groups.html',
                    controller: 'PhoneCallResultGroupController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    /*
                    value: 'id,asc',
                    */
                    value: 'name,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('phoneCallResultGroup');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('phone-call-result-group-detail', {
            parent: 'phone-call-result-group',
            url: '/phone-call-result-group/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'telestatApp.phoneCallResultGroup.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/phone-call-result-group/phone-call-result-group-detail.html',
                    controller: 'PhoneCallResultGroupDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('phoneCallResultGroup');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'PhoneCallResultGroup', function($stateParams, PhoneCallResultGroup) {
                    return PhoneCallResultGroup.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'phone-call-result-group',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('phone-call-result-group-detail.edit', {
            parent: 'phone-call-result-group-detail',
            url: '/detail/edit',
            data: {
                /*
                authorities: ['ROLE_USER']
                */
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/phone-call-result-group/phone-call-result-group-dialog.html',
                    controller: 'PhoneCallResultGroupDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['PhoneCallResultGroup', function(PhoneCallResultGroup) {
                            return PhoneCallResultGroup.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('phone-call-result-group.new', {
            parent: 'phone-call-result-group',
            url: '/new',
            data: {
                /*
                authorities: ['ROLE_USER']
                */
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/phone-call-result-group/phone-call-result-group-dialog.html',
                    controller: 'PhoneCallResultGroupDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                name: null,
                                caption: null,
                                purposeful: false,
                                effect: null,
                                style: null,
                                code: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('phone-call-result-group', null, { reload: 'phone-call-result-group' });
                }, function() {
                    $state.go('phone-call-result-group');
                });
            }]
        })
        .state('phone-call-result-group.edit', {
            parent: 'phone-call-result-group',
            url: '/{id}/edit',
            data: {
                /*
                authorities: ['ROLE_USER']
                */
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/phone-call-result-group/phone-call-result-group-dialog.html',
                    controller: 'PhoneCallResultGroupDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['PhoneCallResultGroup', function(PhoneCallResultGroup) {
                            return PhoneCallResultGroup.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('phone-call-result-group', null, { reload: 'phone-call-result-group' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('phone-call-result-group.delete', {
            parent: 'phone-call-result-group',
            url: '/{id}/delete',
            data: {
                /*
                authorities: ['ROLE_USER']
                */
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/phone-call-result-group/phone-call-result-group-delete-dialog.html',
                    controller: 'PhoneCallResultGroupDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['PhoneCallResultGroup', function(PhoneCallResultGroup) {
                            return PhoneCallResultGroup.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('phone-call-result-group', null, { reload: 'phone-call-result-group' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();
